"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { signOut } from "next-auth/react"
import { useApolloClient } from "@apollo/client/react"
import updateErrorMessage from "../../graphql/mutations/snackbarMessage/updateErrorMessage"
import updateSuccessMessage from "../../graphql/mutations/snackbarMessage/updateSuccessMessage"

const useSignOutClient = () => {
  const apolloClient = useApolloClient()
  const handleSignOut = async () => {
    try {
      await signOut({ redirect: false })
      await apolloClient.clearStore()
      // console.log("sign out success.")
      updateSuccessMessage("You have been signed out")
    } catch (error) {
      updateErrorMessage(
        `Sign-out failed: ${error instanceof Error ? error.message : String(error)}`,
      )
      // throw error
    }
  }
  return {
    handleSignOut,
  }
}
export default useSignOutClient
